import ApplicationElement from '@crossiety/lit-components/components/application_element/element.js';
import style from './style.lit.css';

ApplicationElement.styles.push(style);
ApplicationElement.customConfig['ef-avatar'] = {
  disableInitials: true,
};
